import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// SSO Portail : objet user passé en query par /api/sso/login -> stocké avant le rendu.
(function () { try { const s = new URLSearchParams(window.location.search).get('sso_user'); if (s) { localStorage.setItem('stock_user', decodeURIComponent(escape(atob(s)))); window.history.replaceState(null, '', window.location.pathname); } } catch (e) {} })();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('[SW] Enregistré:', registration.scope);
        })
        .catch(err => {
          console.warn('[SW] Enregistrement échoué:', err);
        });
    });
  } else {
    // En développement, on s'assure de désenregistrer tout SW existant
    // pour éviter les boucles de rechargement causées par un build précédent
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister().then(() => {
          console.log('[SW] Désenregistré proactivement (Mode Dev)');
          // Optionnel: On ne force pas le reload ici pour ne pas créer de boucle
        });
      }
    });
  }
}
